<div class ="main">
    <div class ="header">
        <iframe src="https://3dwarehouse.sketchup.com/embed/21efaea32bdc60aa791c5e79979be5c4" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" width="100%" height="100%" allowfullscreen></iframe>
        <audio autoplay loop src="./../../assets/Audios/beachbg.mp3"></audio>
    </div>
</div>
